module.exports = __webpack_public_path__ + "static/img/logo.827d5ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 1992
// module chunks = 3